import { createRouter, createWebHistory } from 'vue-router'
import DashboardView from '../modules/dashboard/views/DashboardView.vue'
import LoginView from '../modules/auth/views/LoginView.vue'
import AddMenuView from '../modules/menus/views/AddMenuView.vue'
import EditMenuView from '../modules/menus/views/EditMenuView.vue'
import ParametrosView from '../modules/parametros/views/ParametrosView.vue'
import AddParametroView from '../modules/parametros/views/AddParametroView.vue'
import EditParametroView from '../modules/parametros/views/EditParametroView.vue'
import UsuariosView from '../modules/usuarios/views/UsuariosView.vue'
import AddUsuarioView from '../modules/usuarios/views/AddUsuarioView.vue'
import EditUsuarioView from '../modules/usuarios/views/EditUsuarioView.vue'
import GrupousView from '../modules/grupos/GrupousView.vue'
import AddGrupouView from '../modules/grupos/AddGrupouView.vue'
import EditGrupouView from '../modules/grupos/EditGrupouView.vue'
import MenuTableView1 from '../modules/menus/views/MenuTableView1.vue'
import MenuTableView2 from '../modules/menus/views/MenuTableView2.vue'
import MenuTableView3 from '../modules/menus/views/MenuTableView3.vue'
import MenuTableView4 from '../modules/menus/views/MenuTableView4.vue'
import MenusSelectionView from '../modules/menus/views/MenusSelectionView.vue'
import ModulosView from '../modules/modulos/views/ModulosView.vue'
import AddModuloView from '../modules/modulos/views/AddModuloView.vue'
import EditModuloView from '../modules/modulos/views/EditModuloView.vue'
import DemoCrudIntView from '../modules/demoCrudInt/views/DemoCrudIntView.vue'
import DemoCrudCharView from '../modules/demoCrudChar/views/DemoCrudCharView.vue'
import DemoCrudChar2View from '../modules/demoCrudChar2/views/DemoCrudChar2View.vue'
import MotivosRechazoView from '../modules/motivosRechazo/views/MotivosRechazoView.vue'
import AddMotivoRechazoView from '../modules/motivosRechazo/views/AddMotivoRechazoView.vue'
import EditMotivoRechazoView from '../modules/motivosRechazo/views/EditMotivoRechazoView.vue'
import PerfilView from '../modules/auth/views/PerfilView.vue'

// Importaciones para catálogos (MODO1)
import { CatAlmacenView, CatMonedaView, CatCecoView, CatDepartamentoView, CatMaterialView, CatSocioNegocioView, CatEmpleadoView, CatCuentaContableView, CatDimensionView, CatErpView, CatEstadoView, CatGrupoMaterialView, CatImpuestoView, CatMapeoErpView, CatMaterialAlmacenView, CatObjetoView, CatProyectoView, CatSerieView, CatUMedidaView, CatGrupoEmpleadoView, CatMotivosRechazoView } from '../modules/catalogos/index.js'

// Importaciones para el módulo de pedidos de compra (importación diferida para mejor rendimiento)
const PedidosList = () => import('../modules/compras/views/pedidos/PedidosList.vue')
const PedidoCompraForm = () => import('../modules/compras/views/pedidos/PedidoCompraForm.vue')

// Importaciones para el módulo de requisiciones de compra
const RequisicionList = () => import('../modules/compras/requisiciones/views/RequisicionList.vue')
const RequisicionForm = () => import('../modules/compras/requisiciones/views/RequisicionForm.vue')

// Importaciones para el módulo de usuarios de compra
const UsuarioList = () => import('../modules/compras/usuarios/views/UsuarioList.vue')
const UsuarioForm = () => import('../modules/compras/usuarios/views/UsuarioForm.vue')

// Importaciones para el módulo de matriz de autorización
const MatrizAutorizacionForm = () => import('../modules/compras/matriz-autorizacion/views/MatrizAutorizacionForm.vue')

// Importaciones para el módulo de reporte general
const ReporteGeneralList = () => import('../modules/compras/reporte-general/views/ReporteGeneralList.vue')

// Importaciones para el módulo de listas de precios
const ListaPreciosView = () => import('../modules/modulito/listaprecios/views/ListaPreciosView.vue')

import Posw2ComprasView from '../modules/compras/views/Posw2ComprasView.vue'
import DebugAccessView from '../views/DebugAccessView.vue'

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: DashboardView,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/perfil',
    name: 'perfil',
    component: PerfilView,
    meta: { requiresAuth: true }
  },
  {
    path: '/menus',
    name: 'menus',
    component: () => import('../modules/menus/views/MenusView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/menus/add',
    name: 'add-menu',
    component: AddMenuView,
    meta: { requiresAuth: true }
  },
  {
    path: '/menus/edit/:id',
    name: 'edit-menu',
    component: EditMenuView,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/parametros',
    name: 'parametros',
    component: ParametrosView,
    meta: { requiresAuth: true }
  },
  {
    path: '/parametros/add',
    name: 'add-parametro',
    component: AddParametroView,
    meta: { requiresAuth: true }
  },
  {
    path: '/parametros/edit/:clave',
    name: 'edit-parametro',
    component: EditParametroView,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/usuarios',
    name: 'usuarios',
    component: UsuariosView,
    meta: { requiresAuth: true }
  },
  {
    path: '/usuarios/add',
    name: 'add-usuario',
    component: AddUsuarioView,
    meta: { requiresAuth: true }
  },
  {
    path: '/usuarios/edit/:id',
    name: 'edit-usuario',
    component: EditUsuarioView,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/grupous',
    name: 'grupous',
    component: GrupousView,
    meta: { requiresAuth: true }
  },
  {
    path: '/grupous/add',
    name: 'add-grupou',
    component: AddGrupouView,
    meta: { requiresAuth: true }
  },
  {
    path: '/grupous/edit/:code',
    name: 'edit-grupou',
    component: EditGrupouView,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/menus-table1',
    name: 'menus-table1',
    component: MenuTableView1,
    meta: { requiresAuth: true }
  },
  {
    path: '/menus-table2',
    name: 'menus-table2',
    component: MenuTableView2,
    meta: { requiresAuth: true }
  },
  {
    path: '/menus-table3',
    name: 'menus-table3',
    component: MenuTableView3,
    meta: { requiresAuth: true }
  },
  {
    path: '/menus-selection',
    name: 'menus-selection',
    component: MenusSelectionView,
    meta: { requiresAuth: true }
  },
  {
    path: '/menus-table4',
    name: 'menus-table4',
    component: MenuTableView4,
    meta: { requiresAuth: true }
  },
  {
    path: '/config/modulos',
    name: 'modulos',
    component: ModulosView,
    meta: { requiresAuth: false }
  },
  {
    path: '/config/modulos/add',
    name: 'add-modulo',
    component: AddModuloView,
    meta: { requiresAuth: false }
  },
  {
    path: '/config/modulos/edit/:id',
    name: 'edit-modulo',
    component: EditModuloView,
    props: true,
    meta: { requiresAuth: false }
  },
  {
    path: '/motivos-rechazo',
    name: 'motivos-rechazo',
    component: MotivosRechazoView,
    meta: { requiresAuth: true }
  },
  {
    path: '/motivos-rechazo/add',
    name: 'add-motivo-rechazo',
    component: AddMotivoRechazoView,
    meta: { requiresAuth: true }
  },
  {
    path: '/motivos-rechazo/edit/:id',
    name: 'edit-motivo-rechazo',
    component: EditMotivoRechazoView,
    props: true,
    meta: { requiresAuth: true }
  },
  // ==================================================
  // Módulo Demo CRUD Int
  // ==================================================
  {
    path: '/demo/crudint',
    name: 'demo-crud-int',
    component: DemoCrudIntView,
    meta: { requiresAuth: true }
  },
  // ==================================================
  // Módulo Demo CRUD Char
  // ==================================================
  {
    path: '/demo/crudchar',
    name: 'demo-crud-char',
    component: DemoCrudCharView,
    meta: { requiresAuth: true }
  },
  // ==================================================
  // Módulo Demo CRUD Char2
  // ==================================================
  {
    path: '/demo/crudchar2',
    name: 'demo-crud-char2',
    component: DemoCrudChar2View,
    meta: { requiresAuth: true }
  },
  // ==================================================
  // Módulo de Pedidos de Compra
  // ==================================================
  {
    path: '/compras/pedidos',
    name: 'pedidos-list',
    component: PedidosList,
    meta: { 
      requiresAuth: true,
      title: 'Pedidos de Compra',
      breadcrumb: 'Listado',
      module: 'compras',
      permission: 'read'
    }
  },
  {
    path: '/compras/pedidos/nuevo',
    name: 'pedido-nuevo',
    component: PedidoCompraForm,
    meta: { 
      requiresAuth: true,
      title: 'Nuevo Pedido de Compra',
      breadcrumb: 'Nuevo',
      module: 'compras',
      permission: 'create'
    }
  },
  {
    path: '/compras/pedidos/editar/:id(\\d+)', // Solo acepta números como ID
    name: 'pedido-editar',
    component: PedidoCompraForm,
    props: (route) => ({ 
      id: Number(route.params.id),
      modoEdicion: true 
    }),
    meta: { 
      requiresAuth: true,
      title: 'Editar Pedido de Compra',
      breadcrumb: 'Editar',
      module: 'compras',
      permission: 'update'
    }
  },
  {
    path: '/compras/pedidos/ver/:id(\\d+)', // Solo acepta números como ID
    name: 'pedido-ver',
    component: PedidoCompraForm,
    props: (route) => ({
      id: Number(route.params.id),
      modoLectura: true 
    }),
    meta: { 
      requiresAuth: true,
      title: 'Ver Pedido de Compra',
      breadcrumb: 'Ver Detalle',
      module: 'compras',
      permission: 'read'
    }
  },
  // Redirección para rutas no válidas
  {
    path: '/compras/pedidos/:pathMatch(.*)*',
    redirect: { name: 'pedidos-list' }
  },
  // ==================================================
  // Módulo de Requisiciones de Compra
  // ==================================================
  {
    path: '/compras/requisiciones',
    name: 'requisiciones-list',
    component: RequisicionList,
    meta: { 
      requiresAuth: true,
      title: 'Requisiciones de Compra',
      breadcrumb: 'Listado',
      module: 'compras',
      permission: 'read'
    }
  },
  {
    path: '/compras/requisiciones/nuevo',
    name: 'requisicion-nuevo',
    component: RequisicionForm,
    meta: { 
      requiresAuth: true,
      title: 'Nueva Requisición de Compra',
      breadcrumb: 'Nueva',
      module: 'compras',
      permission: 'create'
    }
  },
  {
    path: '/compras/requisiciones/editar/:id(\\d+)',
    name: 'requisicion-editar',
    component: RequisicionForm,
    props: (route) => ({ 
      id: Number(route.params.id),
      modoEdicion: true 
    }),
    meta: { 
      requiresAuth: true,
      title: 'Editar Requisición de Compra',
      breadcrumb: 'Editar',
      module: 'compras',
      permission: 'update'
    }
  },
  {
    path: '/compras/requisiciones/ver/:id(\\d+)',
    name: 'requisicion-ver',
    component: RequisicionForm,
    props: (route) => ({
      id: Number(route.params.id),
      modoLectura: true 
    }),
    meta: { 
      requiresAuth: true,
      title: 'Ver Requisición de Compra',
      breadcrumb: 'Ver Detalle',
      module: 'compras',
      permission: 'read'
    }
  },
  // Redirección para rutas no válidas
  {
    path: '/compras/requisiciones/:pathMatch(.*)*',
    redirect: { name: 'requisiciones-list' }
  },
  // ==================================================
  // Módulo de Usuarios de Compra
  // ==================================================
  {
    path: '/compras/listausuarios',
    name: 'usuario-list',
    component: UsuarioList,
    meta: { 
      requiresAuth: true,
      title: 'Usuarios de Compra',
      breadcrumb: [
        { name: 'Compras', path: '/compras' },
        { name: 'Usuarios', path: '/compras/listausuarios' }
      ]
    }
  },
  {
    path: '/compras/usuarios/nuevo',
    name: 'usuario-nuevo',
    component: UsuarioForm,
    meta: { 
      requiresAuth: true,
      title: 'Nuevo Usuario',
      breadcrumb: [
        { name: 'Compras', path: '/compras' },
        { name: 'Usuarios', path: '/compras/listausuarios' },
        { name: 'Nuevo', path: '/compras/usuarios/nuevo' }
      ]
    }
  },
  {
    path: '/compras/usuarios/editar/:id',
    name: 'usuario-editar',
    component: UsuarioForm,
    props: (route) => ({ 
      id: route.params.id,
      modoEdicion: true 
    }),
    meta: { 
      requiresAuth: true,
      title: 'Editar Usuario',
      breadcrumb: [
        { name: 'Compras', path: '/compras' },
        { name: 'Usuarios', path: '/compras/listausuarios' },
        { name: 'Editar', path: '/compras/usuarios/editar' }
      ]
    }
  },
  // Redirección para rutas no válidas de usuarios
  {
    path: '/compras/usuarios/:pathMatch(.*)*',
    redirect: { name: 'usuario-list' }
  },
  // ==================================================
  // Módulo de Reporte General
  // ==================================================
  {
    path: '/compras/reportegeneral',
    name: 'reporte-general-list',
    component: ReporteGeneralList,
    meta: { 
      requiresAuth: true,
      title: 'Reporte General',
      breadcrumb: [
        { name: 'Compras', path: '/compras' },
        { name: 'Reporte General', path: '/compras/reportegeneral' }
      ]
    }
  },
  // Redirección para rutas no válidas de reporte general
  {
    path: '/compras/reportegeneral/:pathMatch(.*)*',
    redirect: { name: 'reporte-general-list' }
  },
  // ==================================================
  // Módulo de Matriz de Autorización
  // ==================================================
  {
    path: '/compras/matrizautorizacion',
    name: 'matrizautorizacion',
    component: MatrizAutorizacionForm,
    meta: { 
      requiresAuth: true,
      title: 'Matriz de Autorización',
      breadcrumb: [
        { text: 'Compras', active: false },
        { text: 'Matriz de Autorización', active: true }
      ]
    }
  },
  // ==================================================
  // Módulo de Listas de Precios
  // ==================================================
  {
    path: '/compras/listaprecios',
    name: 'lista-precios',
    component: ListaPreciosView,
    meta: { 
      requiresAuth: true,
      title: 'Listas de Precios',
      breadcrumb: 'Listas de Precios',
      module: 'listaprecios',
      permission: 'read'
    }
  },
  // ==================================================
  // Módulo de Compras de Chatarra - POS
  // ==================================================
  {
    path: '/posw2/compras',
    name: 'Posw2Compras',
    component: Posw2ComprasView,
    meta: { 
      requiresAuth: true,
      title: 'Compras de Chatarra - Dos Pesos',
      breadcrumb: 'Compras POS',
      module: 'posw2',
      permission: 'create'
    }
  },
  // ==================================================
  // Página de Debug - Temporal
  // ==================================================
  {
    path: '/debug-access',
    name: 'debug-access',
    component: DebugAccessView,
    meta: { requiresAuth: false }
  },
  // ==================================================
  // Catálogos - MODO1 de nomenclatura
  // ==================================================
  {
    path: '/catalogos/almacenes',
    name: 'cat-almacen',
    component: CatAlmacenView,
    meta: { 
      requiresAuth: true,
      title: 'Catálogo de Almacenes',
      breadcrumb: 'Catálogos > Almacenes'
    }
  },
    {
      path: '/catalogos/moneda',
      name: 'cat-moneda',
      component: CatMonedaView,
      meta: { 
        requiresAuth: true,
        title: 'Catálogo de Monedas',
        breadcrumb: 'Catálogos > Monedas'
      }
    },
  {
    path: '/catalogos/cecos',
    name: 'cat-ceco',
    component: CatCecoView,
    meta: { 
      requiresAuth: true,
      title: 'Catálogo de Centros de Costo',
      breadcrumb: 'Catálogos > Centros de Costo'
    }
  },
    {
      path: '/catalogos/departamento',
      name: 'cat-departamento',
      component: CatDepartamentoView,
      meta: { 
        requiresAuth: true,
        title: 'Catálogo de Departamentos',
        breadcrumb: 'Catálogos > Departamentos'
      }
    },
  {
      path: '/catalogos/material',
    name: 'cat-material',
    component: CatMaterialView,
    meta: { 
      requiresAuth: true,
      title: 'Catálogo de Materiales',
      breadcrumb: 'Catálogos > Materiales'
    }
  },
    {
      path: '/catalogos/socionegocio',
      name: 'cat-socionegocio',
      component: CatSocioNegocioView,
      meta: { 
        requiresAuth: true,
        title: 'Catálogo de Socios de Negocio',
        breadcrumb: 'Catálogos > Socios de Negocio'
      }
    },
    {
      path: '/catalogos/empleado',
      name: 'cat-empleado',
      component: CatEmpleadoView,
      meta: { 
        requiresAuth: true,
        title: 'Catálogo de Empleados',
        breadcrumb: 'Catálogos > Empleados'
      }
    },
    {
      path: '/catalogos/cuentas',
      name: 'cat-cuenta-contable',
      component: CatCuentaContableView,
      meta: { 
        requiresAuth: true,
        title: 'Catálogo de Cuentas Contables',
        breadcrumb: 'Catálogos > Cuentas Contables'
      }
    },
    {
      path: '/catalogos/dimensiones',
      name: 'cat-dimension',
      component: CatDimensionView,
      meta: { 
        requiresAuth: true,
        title: 'Catálogo de Dimensiones',
        breadcrumb: 'Catálogos > Dimensiones'
      }
    },
    {
      path: '/catalogos/erp',
      name: 'cat-erp',
      component: CatErpView,
      meta: { 
        requiresAuth: true,
        title: 'Catálogo de ERPs',
        breadcrumb: 'Catálogos > ERPs'
      }
    },
    {
      path: '/catalogos/estado',
      name: 'cat-estado',
      component: CatEstadoView,
      meta: { 
        requiresAuth: true,
        title: 'Catálogo de Estados',
        breadcrumb: 'Catálogos > Estados'
      }
    },
    {
      path: '/catalogos/grupomaterial',
      name: 'cat-grupo-material',
      component: CatGrupoMaterialView,
      meta: { 
        requiresAuth: true,
        title: 'Catálogo de Grupos de Materiales',
        breadcrumb: 'Catálogos > Grupos de Materiales'
      }
    },
    {
      path: '/catalogos/impuesto',
      name: 'cat-impuesto',
      component: CatImpuestoView,
      meta: { 
        requiresAuth: true,
        title: 'Catálogo de Impuestos',
        breadcrumb: 'Catálogos > Impuestos'
      }
    },
    {
      path: '/catalogos/mapeoerp',
      name: 'cat-mapeo-erp',
      component: CatMapeoErpView,
      meta: { 
        requiresAuth: true,
        title: 'Catálogo de Mapeo ERP',
        breadcrumb: 'Catálogos > Mapeo ERP'
      }
    },
    {
      path: '/catalogos/materialalmacen',
      name: 'cat-material-almacen',
      component: CatMaterialAlmacenView,
      meta: { 
        requiresAuth: true,
        title: 'Catálogo de Material en Almacenes',
        breadcrumb: 'Catálogos > Material en Almacenes'
      }
    },
    {
      path: '/catalogos/objeto',
      name: 'cat-objeto',
      component: CatObjetoView,
      meta: { 
        requiresAuth: true,
        title: 'Catálogo de Objetos',
        breadcrumb: 'Catálogos > Objetos'
      }
    },
    {
      path: '/catalogos/proyecto',
      name: 'cat-proyecto',
      component: CatProyectoView,
      meta: { 
        requiresAuth: true,
        title: 'Catálogo de Proyectos',
        breadcrumb: 'Catálogos > Proyectos'
      }
    },
    {
      path: '/catalogos/serie',
      name: 'cat-serie',
      component: CatSerieView,
      meta: { 
        requiresAuth: true,
        title: 'Catálogo de Series',
        breadcrumb: 'Catálogos > Series'
      }
    },
    {
      path: '/catalogos/umedida',
      name: 'cat-umedida',
      component: CatUMedidaView,
      meta: { 
        requiresAuth: true,
        title: 'Catálogo de Unidades de Medida',
        breadcrumb: 'Catálogos > Unidades de Medida'
      }
    },
    {
      path: '/catalogos/grupoempleado',
      name: 'cat-grupo-empleado',
      component: CatGrupoEmpleadoView,
      meta: {
        requiresAuth: true,
        title: 'Catálogo de Grupos de Empleados',
        breadcrumb: 'Catálogos > Grupos de Empleados'
      }
    },
    {
      path: '/catalogos/motivos-rechazo',
      name: 'cat-motivos-rechazo',
      component: CatMotivosRechazoView,
      meta: {
        requiresAuth: true,
        title: 'Catálogo de Motivos de Rechazo',
        breadcrumb: 'Catálogos > Motivos de Rechazo'
      }
    },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Protección de rutas
import authService from '../services/auth'

// Función para verificar si una ruta está permitida para el usuario actual
const isRouteAllowed = (routePath) => {
  // Si la ruta es login, siempre está permitida
  if (routePath === '/login') {
    return true;
  }

  // Si el usuario está autenticado y va al dashboard o a su perfil, permitir siempre.
  if (routePath === '/' || routePath === '/perfil') {
    return true;
  }
  
  // TEMPORAL: Permitir acceso a la ruta de compras y catálogos para pruebas
  if (routePath === '/posw2/compras' || routePath === '/test' || routePath === '/debug-access' || 
      routePath === '/demo/crudint' || routePath === '/demo/crudchar' || routePath === '/demo/crudchar2' ||
      routePath === '/compras/listaprecios' || routePath.startsWith('/catalogos/') || routePath.startsWith('/compras/') || routePath.startsWith('/luis/')) {
     return true;
   }
  
  // Obtener el usuario y sus menús/módulos
  const userData = authService.getUserData();
  if (!userData || !userData._UsuarioMo) {
    return false;
  }
  
  // Normalizar la ruta (quitar el primer slash si existe)
  const normalizedPath = routePath.startsWith('/') ? routePath.substring(1) : routePath;
  
  // Verificar si la ruta está en _MenuList.Enlace
  if (userData._UsuarioMo && userData._UsuarioMo._MenuList && Array.isArray(userData._UsuarioMo._MenuList)) {
    const menuMatch = userData._UsuarioMo._MenuList.some(menu => {
      // Normalizar el enlace del menú (puede o no tener slash inicial)
      const menuPath = menu.Enlace && menu.Enlace.startsWith('/') ? menu.Enlace.substring(1) : menu.Enlace || '';
      return menuPath === normalizedPath || normalizedPath.startsWith(menuPath + '/');
    });
    
    if (menuMatch) {
      return true;
    }
  }
  
  // Verificar si la ruta está en _ModuloList.Ruta
  if (userData._UsuarioMo && userData._UsuarioMo._ModuloList && Array.isArray(userData._UsuarioMo._ModuloList)) {
    const moduleMatch = userData._UsuarioMo._ModuloList.some(modulo => {
      // Normalizar la ruta del módulo (puede o no tener slash inicial)
      const modulePath = modulo.Ruta && modulo.Ruta.startsWith('/') ? modulo.Ruta.substring(1) : modulo.Ruta || '';
      return modulePath === normalizedPath || normalizedPath.startsWith(modulePath + '/');
    });
    
    if (moduleMatch) {
      return true;
    }
  }
  
  // Si llegamos aquí, la ruta no está permitida
  return false;
};

router.beforeEach((to, from, next) => {
  // Verificar si la ruta requiere autenticación
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Verificar si el usuario está autenticado
    if (!authService.isAuthenticated()) {
      // Redirigir a la página de login
      next({ name: 'login' });
      return;
    }
    
    // Verificar si la ruta está permitida para el usuario
    if (isRouteAllowed(to.path)) {
      // Usuario autenticado y ruta permitida
      next();
    } else {
      // Ruta no permitida, redirigir al dashboard
      console.warn(`Acceso denegado a la ruta: ${to.path}. No está en MenuList.Enlace ni en ModuloList.Ruta`);
      next({ name: 'dashboard' });
    }
  } else {
    // Ruta pública, permitir acceso
    next();
  }
})

export default router
